'use strict';

function Overview() {
  this.id = null;
  this.node = null;
  this.extends = [];

  this.contentType = 'overview';
  this.contentId = ''; // contentId defined in pug file

  this.elements = {};
  this.waitlistActionPayload = null; // override at component level.
  this.isWaitlisted = null; // override at component level.
  this.analyticsCallbacks = {
    waitlistSuccess: null // analytics success event for soa request, implement at product level (e.g. "bump me up" for Spend)
  };

  this.init = function () {};

  this.initAllReady = function () {};

  this.initOverview = function () {
    var _this = this;

    this.contentRef = 'content.' + this.contentType + '.' + this.contentId;
    this._product = new Product(this.contentRef, this.presenter);

    this._portalPresenter = document.getElementById('Portal').mogo();

    this._product.pushPageViewAnalyticsEvent();
    this._product.pushContentfulAnalyticsEvent();

    // content elements:
    this.elements.media = this.node.querySelector('.js--media');
    this.elements.buttonList = this.node.querySelector('.js--button-list');
    this.elements.primaryCta = this.node.querySelector('.js--primary-cta');
    this.elements.waitlist = this.node.querySelector('.js--waitlist');
    this.elements.statusContent = this.node.querySelector('.js--status-content');
    this.elements.highlight = this.node.querySelector('.js--highlight');
    this.overviewApps = this.node.querySelector('.js--overview-apps');
    // load required components:

    // load optional components:
    if (this.elements.media) {
      this._product.loadMedia(this.elements.media);
    }
    if (this.elements.buttonList) {
      this._product.loadButtonList(this.elements.buttonList);
    }
    if (this.elements.primaryCta) {
      this._product.loadPrimaryCta(this.elements.primaryCta, 'nav-action-1'); // should id come from dom?
    } else if (this.elements.waitlist) {
      // setup soa action cta
      this._product.loadWaitlist(this.elements.waitlist, 'soa-action-1', 'account', this.waitlistActionPayload, this.isWaitlisted, function (data, res) {
        if (res === 200 && _this.analyticsCallbacks.waitlistSuccess) {
          _this.analyticsCallbacks.waitlistSuccess();
        }
      });
    }

    this.overviewApps.click(this.overviewAppAnalytics);

    // this.presenter._contentLoadedPromise
    $.when(this.presenter._contentLoadedPromise).done(function () {
      if (_this._product._contentModel.statusTitle) {
        _this.elements.statusContent.classList.remove('hide');
      }
      if (_this._product._contentModel.highlight) {
        _this.elements.highlight.classList.remove('hide');
      }
    });

    if (this.presenter._contentLoadedPromise !== '') {
      if (this._product._contentModel.statusTitle) {
        this.elements.statusContent.classList.remove('hide');
      }
      if (this._product._contentModel.highlight) {
        this.elements.highlight.classList.remove('hide');
      }
    }

    // Required when route has defer_page_load_completed: true
    this._portalPresenter.setPageLoadComplete();

    this.node.classList.remove('hide');
    this._portalPresenter.scanNodeForClickAnalytics(this.node); // scan DAI for dynamically created elements
  };

  this.overviewAppAnalytics = function () {
    dataLayer.push({
      event: 'DLevent.memberNavigation',
      memberNavigation: 'MogoCard-Navigation-Get your free card-Navigation-Component'
    });
  };

  this.destroyOverview = function () {
    if (this._product) {
      this._product.destroy();
    }
  };

  // Template file is not first component extended so don't use these
  this.init = function () {};

  this.initAllReady = function () {};

  this.destroy = function () {};
}